<template>
  <div id="app" class="app">
	   <com-header></com-header>
	   <!--<keep-alive>-->
       	<router-view/>
       <!--</keep-alive>-->
       <com-footer></com-footer>
  </div>
</template>

<script>
	import ComHeader from '@/components/public/ComHeader'
	import ComFooter from '@/components/public/ComFooter'
	export default {
	  name: 'app',
	  components: {
		ComHeader,
		ComFooter
	  },
	  mounted(){

	  }
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue